import Vue from 'vue';

import parse from 'date-fns/format';
import nlLocale from 'date-fns/locale/nl';
import format from './modules/formatDate';

/**
 * Format a datetime string
 *
 * @param {string} datetime - Datetime string that is not very user friendly
 * @param {string} format - The format the datetime string should have
 * @return {string} The blended color.
 */
Vue.filter('dateFormat', (datetime, dateFormat) => {
    if (!datetime) {
        return '';
    }

    return format(parse(datetime), dateFormat);
});

/**
 * Summarizes a players array by firstName key to be used by the booking component.
 * Eg. [{firstName: 'Kyle'},{firstName: 'Martijn'}] becomes Kyle, Martijn
 *
 * @params {Array} players
 * @returns {String}
 */
Vue.filter('summarizeNames', (players) => {
    let result = '';

    for (let index = 0; index < players.length; index++) {
        const player = players[index];
        const firstName = player.defaultNameState ? player.defaults.firstName : player.firstName;
        const lastName = player.defaultNameState ? player.defaults.lastName : player.lastName;

        result += `${firstName} ${lastName}`;

        if (players[index + 1]) {
            result += ', ';
        }
    }

    return result;
});

/**
 * Format a datetime string
 *
 * @param {string} datetime - Datetime string that is not very user friendly
 * @param {string} format - The format the datetime string should have
 * @return {string} The blended color.
 */
Vue.filter('time', (datetime) => {
    if (!datetime) {
        return '';
    }

    return format(parse(datetime), 'HH:mm');
});

/**
 * Abbreviate a day string
 *
 * @param {string} day - A day string like 'Sunday'
 * @param {string} length - The length of the abbreviated string
 * @return {string} Abbreviated day string, like S for 'Sunday'
 */
Vue.filter('day', (day, length) => {
    if (!length) {
        return day.charAt(0);
    }

    return day.charAt(length);
});

/**
 * Format a datetime string
 *
 * @param {string} datetime - Datetime string that is not very user friendly
 * @param {string} format - The format the datetime string should have
 * @return {string} The blended color.
 */
Vue.filter('month', (datetime) => {
    if (!datetime) {
        return '';
    }

    return format(parse(datetime), 'MMMM YYYY');
});

/**
 * Format a datetime string
 *
 * @param {string} datetime - Datetime string that is not very user friendly
 * @param {string} format - The format the datetime string should have
 * @return {string} The blended color.
 */
Vue.filter('schedulerDay', (datetime) => {
    if (!datetime) {
        return '';
    }

    return format(parse(datetime), 'dd DD MMM');
});

/**
 * Returns string without dots in it.
 *
 * @param  {String} string - String that is about to be manipulated.
 * @return {string} The manipulated string.
 */
Vue.filter('noDots', (string) => string);

/**
 * Returns ordinal word for given number.
 *
 * @param  {Number} Can only be 0 to 3, as zero indexes.
 * @return {string} The manipulated string.
 */
Vue.filter('ordinalWord', (number) => {
    const strings = {
        nl: [
            'Eerste', 'Tweede', 'Derde', 'Vierde',
        ],
        en: [
            'First', 'Second', 'Third', 'Fourth',
        ],
    };

    return strings[document.documentElement.lang][number];
});

/**
 * Returns the given string with the first letter as uppercase,
 * the rest lowercase.
 *
 * @param {String}
 * @returns {String}
 */
Vue.filter('upperFirst', (string) => _.upperFirst(_.lowerCase(string)));

Vue.filter('underscoreToSpace', (string) => string.replace(/_/g, ' '));

Vue.filter('memberTypeString', (player, locale = 'en') => {
    if (!player.memberType || player.memberType == 'DAY_MEMBER') {
        if (player.youngAdult) {
            return (locale === 'nl') ? 'Jonger dan 24 jaar' : 'Under 24';
        }

        if (player.member) {
            return 'Member';
        }

        return 'Day Member';
    }

    const data = {
        PRIVATE_MEMBER: 'Private Member',
        STAFF: 'Staff',
        CHILD_BELOW: 'Child Below',
        YOUNG_ADULT: 'Young Adult',
        DAY_MEMBER: 'Day Member',
        PARTNER_CM_PM: 'Partner CM DM',
        CHILD_ABOVE: 'Child Above',
        PARTNER_DM: 'Partner Daymember',
        CHILD_DM: 'Child Daymember',
        POTENTIAL: 'Potential',
        BUSINESS_MEMBER: 'Corporate Member',
    };

    if (data[player.memberType]) {
        return data[player.memberType];
    }

    return (locale === 'nl') ? 'Overige Member' : 'Other Member';
});
